import { useRef, useState } from 'react';
import useAuthStore from 'store/authStore';
import { authorizedCommands } from './commands';
import useReconcileEcocashOrders from 'api/CommandCenterResource/useReconcileEcocashOrders';
import useSyncCurrencyRates from 'api/CommandCenterResource/useSyncCurrencyRates';
import usePublishConfigurations from 'api/CommandCenterResource/usePublishConfigurations';

export default function useCommandRuns() {
    const auth = useAuthStore();
    const reconcile = useReconcileEcocashOrders();
    const configurations = usePublishConfigurations();
    const currencies = useSyncCurrencyRates();
    const [running, setRunning] = useState(null);
    const [results, setResults] = useState({});
    const [activity, setActivity] = useState([]);
    const lock = useRef(false);
    const sequence = useRef(0);

    const run = async (command, hours) => {
        if (lock.current || !authorizedCommands(auth).some((item) => item.id === command.id)) return;
        lock.current = true;
        const id = ++sequence.current;
        const entry = { id, command: command.id, title: command.title, status: 'running', startedAt: Date.now(), hours };
        setRunning(command.id);
        setResults((previous) => ({ ...previous, [command.id]: entry }));
        setActivity((previous) => [entry, ...previous].slice(0, 8));
        let outcome;
        try {
            const response = await ({ reconcile, currencies, configurations })[command.id].mutateAsync(hours);
            const partialSync = command.id === 'currencies' && response?.data?.status === 'partial';
            const status = partialSync || (command.id === 'reconcile' && Number(response?.data?.errors) > 0) ? 'warning' : 'success';
            outcome = { ...entry, status, finishedAt: Date.now(), response,
                message: partialSync ? 'Currency sync finished with skipped rates. Review the details below.'
                    : status === 'warning' ? 'Recovery finished with errors. Review the order details below.' : command.success };
        } catch (error) {
            outcome = { ...entry, status: 'error', finishedAt: Date.now(),
                message: error?.response?.data?.message || 'The command could not be completed. Please try again.' };
        } finally {
            lock.current = false;
            setRunning(null);
        }
        setResults((previous) => ({ ...previous, [command.id]: outcome }));
        setActivity((previous) => previous.map((item) => item.id === id ? outcome : item));
    };
    return { running, results, activity, run };
}
